export const PACKAGES_HOMEPAGE_HEADER_ACCOUNT_NAV_SLOT_ID =
  "packages-homepage-header-account-nav-slot";
